/* eslint-disable no-sequences */
// AXIOS
import axios from "axios";


// api url
import { apiToken, apiUrl_forMultipliers } from "./constants";

// cancel token
const CancelToken = axios.CancelToken;

// get multipliers
export let cancelGetMultipliersApi;
export async function getMultipliers(token) {
    if (token) {
        const multipliers = await axios.get(apiUrl_forMultipliers + "settings/multipliers", {
            headers: {
                Authorization: `Bearer ${token}`,
                "Api-Token": apiToken,
                "Access-Token": "",
            },
            cancelToken: new CancelToken(function executor(c) {
                // An executor function receives a cancel function as a parameter
                cancelGetMultipliersApi = c;
            }),
        });
        return multipliers;
    } else {
        console.log("Please add required parameters");
    }
}

// update multiplier
export let cancelEditMultiplierApi;
export async function editmultipliers(token, multiplierData) {
    if (token, multiplierData) {
        const multipliers = await axios.put(apiUrl_forMultipliers + "settings/multipliers",
            multiplierData,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Api-Token": apiToken,
                    "Access-Token": "",
                },
            },
            {
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    cancelEditMultiplierApi = c;
                }),
            }
        );
        return multipliers;
    } else {
        console.log("Please add required parameters");
    }
}


// update brand multiplier
export let cancelBrandMultiplierApi;
export async function updateBrandMultiplier(token, brandMultiplierData) {
    if (token, brandMultiplierData) {
        const brandMultiplier = await axios.put(apiUrl_forMultipliers + "brands/multipliers",
            { data: brandMultiplierData },
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Api-Token": apiToken,
                    "Access-Token": "",
                },
            },
            {
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    cancelBrandMultiplierApi = c;
                }),
            }
        );
        return brandMultiplier;
    } else {
        console.log("Please add required parameters");
    }
}

// update brand multiplier
export let cancelCategoryMultiplierApi;
export async function updateCategoryMultiplier(token, categoryMultiplierData) {
    if (token, categoryMultiplierData) {
        const categoryMultiplier = await axios.put(apiUrl_forMultipliers + "categories/multipliers",
            { data: categoryMultiplierData },
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Api-Token": apiToken,
                    "Access-Token": "",
                },
            },
            {
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    cancelCategoryMultiplierApi = c;
                }),
            }
        );
        return categoryMultiplier;
    } else {
        console.log("Please add required parameters");
    }
}

// update product multiplier
export let cancelProductMultiplierApi;
export async function updateProductMultiplier(token, productMultiplierData) {
    if (token, productMultiplierData) {
        const productMultiplier = await axios.put(apiUrl_forMultipliers + "products/multipliers",
            { data: productMultiplierData },
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Api-Token": apiToken,
                    "Access-Token": "",
                },
            },
            {
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    cancelProductMultiplierApi = c;
                }),
            }
        );
        return productMultiplier;
    } else {
        console.log("Please add required parameters");
    }
}